import {getApplicationFieldsList} from "../../applicationFields/api/ApplicationFieldsApi.js";
import * as UIUtil from "../../util/UI.js";
import {SEARCH_OPT} from "../../applicationFields/config/ApplicationFieldsConfig.js";
import {getActiveMenuKey, getKeyMenuByParent, getParentKey, openMenu} from "../../common/Menu.js";

let SEARCH = {...SEARCH_OPT.LIST};
let fullApplicationFieldsList = [];
export const open = async function () {
    try {
        // 검색 조건 초기화
        SEARCH = {...SEARCH_OPT.LIST};
        fullApplicationFieldsList = [];

        document.querySelector(".banner")?.remove();
        document.querySelector("section.contents-wrap")?.remove();

        const lang = document.documentElement.lang || 'ko';
        const htmlUrl = `app/html/${lang}/business/ApplicationFields.html`;

        const headerWrap = document.querySelector(".headerWrap");

        const response = await fetch(htmlUrl);
        const html = await response.text();

        headerWrap.insertAdjacentHTML("afterend", html);
        //
        // 검색 입력창 초기화
        const searchInput = document.querySelector(".search-box input[type='search']");
        if (searchInput) {
            searchInput.value = "";
        }

        initTabEvent();
        initSearchEvent();
        await drawList();

    } catch (error) {
        console.error(error);
    }
};
const drawList = async function () {
    const param = {
        ...SEARCH
    };

    const response = await getApplicationFieldsList(param);

    if (!response.SUCCESS) {
        UIUtil.msgBox("검색 실패", "error");
        return;
    }

    const { LIST, TOTAL_COUNT } = response.RESULT;
    fullApplicationFieldsList = LIST;

    const activeTab = document.querySelector(".subtabcontents.on"); // 🔥 현재 활성화된 탭 영역
    if (activeTab) {
        const listEl = activeTab.querySelector(".grid-layout-area.field");
        drawListItems(LIST, listEl);
    }
};

const drawListItems = function (items, listEl) {
    if (!listEl) return;

    listEl.innerHTML = "";

    if (items.length === 0) {
        listEl.innerHTML = `<div class="empty">등록된 활용분야가 없습니다.</div>`;
        return;
    }

    items.forEach((item) => {
        const startYear = item.startYear || "";
        const endYear = item.endYear || "";
        const projectPeriod = startYear ? (endYear ? `${startYear} ~ ${endYear}` : startYear) : "";

        let tagsHtml = "";
        try {
            if (item.tag) {
                const tags = JSON.parse(item.tag);
                tagsHtml = tags.map(tag => `<span>${tag}</span>`).join("");
            }
        } catch (e) {
            console.error("태그 파싱 실패", e);
        }

        let imgHtml = "";
        if (item.appfldImgId) {
            const thumbnailUrl = `/applicationFields/file/view/${item.appfldImgId}`;
            imgHtml = `<img src="${thumbnailUrl}" alt="활용분야 썸네일">`;
        }

        const div = document.createElement("div");
        div.className = "box";

        div.innerHTML = `
            <div class="img-cnt">
                ${imgHtml}
            </div>
            <div class="tit-cnt">
                <div class="cte-cnt">
                    <span class="category">${item.category || ""}</span>
                    <div class="tit">${item.project || ""}</div>
                </div>
                <div class="desc-cnt">
                    <div class="desc-txt">
                        <span>연도</span>
                        <span>${projectPeriod || "-"}</span>
                    </div>
                    <div class="desc-txt">
                        <span>발주처</span>
                        <span>${item.client || "-"}</span>
                    </div>
                </div>
                <div class="tag-cnt">
                    ${tagsHtml}
                </div>
            </div>
        `;
        listEl.appendChild(div);
    });
};
const initTabEvent = function () {
    const tabLinks = document.querySelectorAll(".subtabs li");

    tabLinks.forEach((tab) => {
        tab.addEventListener("click", async function () {
            // 모든 탭 비활성화
            tabLinks.forEach(t => t.classList.remove("on"));
            this.classList.add("on");

            const tabClass = this.classList[0]; // tab01, tab02, tab03...
            const category = getCategoryByTab(tabClass);

            SEARCH.category = category;
            await drawList();
        });
    });

    const homeElement = document.querySelector('.breadcrumb .home');
    const parentElement = document.querySelectorAll('.breadcrumb li a')[1];

    if (homeElement) {
        homeElement.addEventListener('click', () => {
            openMenu('Main');
        });
    }

    if (parentElement) {
        parentElement.addEventListener('click', () => {
            const currentMenuKey = getActiveMenuKey();
            const parentKey = getParentKey(currentMenuKey);
            const firstChildKey = getKeyMenuByParent(parentKey);
            if (firstChildKey) {
                openMenu(firstChildKey);
            }
        });
    }
};

const getCategoryByTab = (tabClass) => {
    switch (tabClass) {
        case "tab02": return "SI/SM";
        case "tab03": return "데이터베이스";
        case "tab04": return "연구/컨설팅";
        case "tab05": return "해외사업";
        default: return "";
    }
};

const initSearchEvent = function () {
    const searchInput = document.querySelector(".search-box input[type='search']");
    const searchBtn = document.querySelector(".search-box button");

    if (!searchInput || !searchBtn) return;

    searchBtn.addEventListener("click", function () {
        const keyword = searchInput.value.trim();
        SEARCH.searchValue = keyword;

        drawList(1);
    });

    searchInput.addEventListener("keypress", function (e) {
        if (e.key === "Enter") {
            searchBtn.click();
        }
    });
};